export const DEFAULT_THEME_NAME = 'default';
